import React from "react";
import { Code2, Server, Database, Cpu, ShieldCheck, Rocket } from "lucide-react";

const JavaDev = () => {
  return (
    <section className="relative bg-gradient-to-b from-[#1e5a8e]/10 via-[#4dd6d5]/10 to-white py-24 overflow-hidden">

      {/* Background Blobs */}
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-[#1e5a8e]/30 rounded-full blur-3xl" />
      <div className="absolute top-20 -right-40 w-[420px] h-[420px] bg-[#4dd6d5]/30 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">

        {/* HERO SECTION */}
        <div className="text-center max-w-4xl mx-auto mb-20">
          <span className="inline-flex px-5 py-2 rounded-full bg-gradient-to-r from-[#1e5a8e] to-[#4dd6d5] text-white font-semibold mb-6">
            NectarSolutions Services
          </span>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-6">
            Java Application Development
            <span className="block bg-gradient-to-r from-[#1e5a8e] to-[#4dd6d5] bg-clip-text text-transparent">
              Scalable & Secure Solutions
            </span>
          </h1>

          <p className="text-lg text-gray-700">
            Build powerful enterprise-grade applications with our expert Java development team.
            We deliver scalable, high-performance, and secure solutions tailored to your business.
          </p>
        </div>

        {/* SERVICES GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">

          {[
            {
              icon: Code2,
              title: "Custom Java Development",
              desc: "Tailor-made Java applications designed to meet your unique business requirements."
            },
            {
              icon: Server,
              title: "Enterprise Applications",
              desc: "Robust and scalable enterprise solutions using Spring Boot, Microservices, and APIs."
            },
            {
              icon: Database,
              title: "Database Integration",
              desc: "Seamless integration with MySQL, PostgreSQL, MongoDB, and other databases."
            },
            {
              icon: Cpu,
              title: "High Performance Systems",
              desc: "Optimized applications with high-speed processing and minimal latency."
            },
            {
              icon: ShieldCheck,
              title: "Secure Architecture",
              desc: "Advanced security implementation including authentication, encryption, and compliance."
            },
            {
              icon: Rocket,
              title: "Cloud & Deployment",
              desc: "Deploy scalable Java apps on AWS, Azure, and cloud-native platforms."
            }
          ].map((item, index) => (
            <div
              key={index}
              className="p-8 rounded-3xl bg-white shadow-lg border border-gray-100
              hover:shadow-xl hover:scale-[1.02] transition"
            >
              <div className="w-14 h-14 rounded-xl bg-gradient-to-r from-[#1e5a8e] to-[#4dd6d5]
              flex items-center justify-center text-white mb-5">
                <item.icon size={26} />
              </div>

              <h3 className="text-xl font-bold mb-2 text-gray-800">
                {item.title}
              </h3>

              <p className="text-gray-600 text-sm">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* PROCESS SECTION */}
        <div className="max-w-5xl mx-auto mb-24">
          <h2 className="text-3xl font-bold text-center mb-12">
            Our Development Process
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">

            {["Planning", "Design", "Development", "Deployment"].map((step, i) => (
              <div
                key={i}
                className="p-6 rounded-2xl bg-gradient-to-r from-[#1e5a8e]/10 to-[#4dd6d5]/10 border"
              >
                <div className="text-3xl font-bold text-[#1e5a8e] mb-2">
                  {i + 1}
                </div>
                <div className="font-semibold text-gray-800">{step}</div>
              </div>
            ))}
          </div>
        </div>

        {/* STATS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
          <div className="text-center p-8 bg-white rounded-3xl shadow-lg border">
            <div className="text-4xl font-bold text-[#1e5a8e] mb-2">100+</div>
            <div className="text-gray-700 font-medium">Projects Delivered</div>
          </div>

          <div className="text-center p-8 bg-white rounded-3xl shadow-lg border">
            <div className="text-4xl font-bold text-[#1e5a8e] mb-2">10+</div>
            <div className="text-gray-700 font-medium">Years Experience</div>
          </div>

          <div className="text-center p-8 bg-white rounded-3xl shadow-lg border">
            <div className="text-4xl font-bold text-[#1e5a8e] mb-2">99%</div>
            <div className="text-gray-700 font-medium">Client Satisfaction</div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center rounded-3xl p-12 bg-gradient-to-r from-[#1e5a8e] via-[#2a9bb0] to-[#4dd6d5] text-white shadow-2xl">
          <h3 className="text-3xl font-bold mb-4">
            Ready to Build Your Java Application?
          </h3>

          <p className="mb-8 max-w-2xl mx-auto text-lg">
            Let’s transform your ideas into powerful Java-based solutions with cutting-edge technology.
          </p>

          <button
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-[#1e5a8e]
            rounded-full font-semibold hover:scale-110 transition hover:shadow-xl text-lg"
          >
            Get Started
          </button>
        </div>

      </div>
    </section>
  );
};

export default JavaDev;